import type { ResponseMessage } from "@kiddocare-platform/portal-common/base";
import { BaseService } from "@kiddocare-platform/portal-common/base";
import type { Policy, PolicyAccepted } from "@kiddocare-platform/portal-common/platform";

export class PlatformLegalService extends BaseService {

  public async getPoliciesByAccount(): Promise<ResponseMessage<Policy[]>> {
    try {
      const response = await this.AxiosInstance.get(`/pediatrician/legal/getPoliciesByAccount`);
      return response.data;
    } catch (error: any) {
      this.log.error("getPoliciesByAccount", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async getAcceptedPoliciesByAccount(): Promise<ResponseMessage<Policy[]>> {
    try {
      const response = await this.AxiosInstance.get(`/pediatrician/legal/getAcceptedPoliciesByAccount`);
      return response.data;
    }
    catch (error: any) {
      this.log.error("GetAcceptedPoliciesByAccount", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async insertUserPolicies(policies: Array<PolicyAccepted>): Promise<ResponseMessage<any>> {
    try {
      const response = await this.AxiosInstance.post(`/pediatrician/legal/insertUserPolicies`, policies);
      return response.data;
    } catch (error: any) {
      this.log.error("InsertUserPolicies", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}